import storage from './storage';
import { generateId } from '../utils/uuid';

function key(userId) {
  return userId ? `crm_time_logs_u${userId}` : 'crm_time_logs';
}

export const timeLogService = {
  getAll(userId) {
    return storage.get(key(userId), []);
  },
  saveAll(userId, rows) {
    storage.set(key(userId), rows);
  },
  add(userId, { leadId, minutes, note }) {
    const rows = this.getAll(userId);
    const row = {
      id: generateId(),
      leadId: String(leadId),
      minutes: Math.max(1, Number(minutes) || 0),
      note: note || '',
      at: new Date().toISOString(),
    };
    this.saveAll(userId, [row, ...rows]);
    return row;
  },
  forLead(userId, leadId) {
    const lid = String(leadId);
    return this.getAll(userId).filter(r => String(r.leadId) === lid);
  },
  sumMinutesForLead(userId, leadId) {
    return this.forLead(userId, leadId).reduce((s, r) => s + (Number(r.minutes) || 0), 0);
  },
};
